
import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";
import { secondaryImage, checkerboarder, views } from "./initialValues";

const UGCEntryPoint = {
  actions,
  getters,
  mutations,
  namespaced: true,
  state: {
    activeView: "",
    availableUGCTools: [],
    orderStyles: [],
    orderStylesApparel: [],
    pdm: {},
    selectableStyles: {},
    sizes: {},
    stepNumber: 1,
    uploadedImageId: "",
    uploadedImageUrl: "",
    uploadedImageType: "",
    uploadedImageWidth: 0,
    uploadedImageHeight: 0,
    secondaryImage: { ...secondaryImage },
    checkerboarder: { ...checkerboarder },
    views: [ ...views ],
    selectedStyle: "",
    selectedStyleName: "",
    headerDesc: "",
    contactDetails: {},
    hasAcceptedTermsAndConditions: false,
    isContactFormValid: false,
    enableEmailGateway: true,
    useSvgRenderer: false,
    enableSmartcrop: false,
    enableControls: true,
    feature: null,
    imageCategories: [],
    imageLibraryId: null,
    imageLibraryCategory: null,
    modelRecipes: {},
    apparelModels: [],
    productType: false,
    source: '',
    switchToApparel: false,
    switchToShoes: false,
    optIn: false,
    enableAutoColorMapping: false,
    colorMappingData: {},
    imageStatus: undefined
  }
};

export default UGCEntryPoint;
